function revealPostCards() {
  const postCards = document.querySelectorAll('.animate-slide-up, .animate-fade-in');
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.bottom >= 0 && rect.top <= windowHeight;
  }

  postCards.forEach((card) => {
    if (isInViewport(card)) {
      card.classList.add('is-visible');
    }
  });
}

export default function initRevealPostCards() {
  revealPostCards();
  let timeout;
  window.addEventListener('scroll', () => {
    clearTimeout(timeout);
    timeout = setTimeout(revealPostCards, 100);
  });
}